import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import axios, { CancelTokenSource } from 'axios';

import { FetchHookResponse } from '../types/hooks/hooksTypes';
import { CollectionVariantDownload } from '../types/api/DownloadsTypes';
import { CollectionsShowResponse } from '../types/api/CollectionsShowTypes';
import { User } from '../types/api/UsersTypes';
import { GenericResponse } from '../types/api/Http';
import { AxiosResponse, AxiosError } from 'axios';

export default function getCollectionDownloads(
  collection: CollectionsShowResponse,
  user: User,
): FetchHookResponse<Array<CollectionVariantDownload>> {
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string>(null);
  const [downloads, setDownloads] = useState<Array<CollectionVariantDownload>>(null);

  const dispatch = useDispatch();

  let cancelTokenSource: CancelTokenSource;

  const fetchDownloads = async () => {
    cancelTokenSource = axios.CancelToken.source();

    dispatch({
      type: 'GET_COLLECTION_DOWNLOAD_LINKS',
      api: {
        method: 'GET',
        url: `/variant_downloads/collections/${collection.id}`,
        headers: { authorization: user.token },
        onError: (res: AxiosError) => {
          if (axios.isCancel(res)) {
            setLoading(false);
            return false;
          }
          setLoading(false);
          setError((res as AxiosError).message);
          return false;
        },
        onSuccess: (res: AxiosResponse<GenericResponse<Array<CollectionVariantDownload>>>) => {
          setLoading(false);
          setDownloads(res?.data?.data || []);
        }
      }
    });
  }

  useEffect(() => {
    if (!collection || !user) return;

    setError(null);
    fetchDownloads();

    return () => {
      cancelTokenSource?.cancel('callCancelled');
    }
  }, [collection, user]);

  return {
    loading,
    error,
    data: downloads,
  };
}
